import { Injectable } from '@angular/core';
import {BrandType} from "../../signup/models/brand-type";
import {FacadeService} from "../../shared/service-facade/facade.service";

@Injectable({
  providedIn: 'root'
})
export class BrandService {

  constructor(private facadeService : FacadeService) { }

  getAlloyJourneyRouteInput(brandId : number) : string {
    let route : string = "";

    switch (brandId) {
      case BrandType.BaskBank: route = "Bask_Consumer"; break;
      case BrandType.PrivateWealth: route = "PWA"; break;
      case BrandType.TexasCapitalBank:
        if (this.facadeService.isFromBranch())
          route = "Branch";
        else if (this.facadeService.getIsEmployeeProduct())
          route = "Employee";
        else
          route = "Consumer";
        break;
      default:
        route = "";
    }

    return route;
  }
}
